import { Component } from 'react';
import {
  Row,
  Col,
  Card,
  ListGroup,
  Dropdown,
  Accordion,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Layout from './DashboardLayout';
import { countrySiteService } from '../services';
import Loading from '../components/Loader';
import {
  WithConfirmation,
  AccordionToggle,
  NoDataAlert,
} from '../components/common';
import AddNewSite from '../components/country-site/AddNewSite';
import EditSite from '../components/country-site/EditSite';
import { groupBy } from '../helpers';

// Delete a site - link
const DeleteLink = ({ handleShow }) => (
  <Dropdown.Item onClick={handleShow}>Delete Site</Dropdown.Item>
);
DeleteLink.propTypes = {
  handleShow: PropTypes.func,
};

// Delete a site - confirmation modal
const DeleteTeam = ({ deleteProp }) => {
  const DeleteSectionWithConfirmation = WithConfirmation(DeleteLink);
  const DeleteModalProps = {
    title: `Delete Site`,
    action: deleteProp,
    content: [
      `You're about to delete a site. All data will be permanently deleted. You will not be able to restore it later.`,
      'Do you want to delete it?',
    ],
    actionBtnText: 'Delete',
  };
  return <DeleteSectionWithConfirmation modalProps={DeleteModalProps} />;
};
DeleteTeam.propTypes = {
  deleteProp: PropTypes.func,
};

class CountryAndSites extends Component {
  state = {
    isLoading: false,
    teamList: [],
    countryList: [],
    teamMembersList: [],
    showAddSiteModal: false,
    showEditSiteModal: false,
    selectedSite: {},
    sitesCount: 0,
    sitesList: {},
  };

  pageHeading = {
    preTitle: 'Manage',
    title: `Country and Sites`,
  };

  componentDidMount() {
    this.handleGetCountyList();
    this.handleGetSitesList();
  }

  handleGetCountyList = async () => {
    countrySiteService.get_country_list().then((response) => {
      if (response.data) {
        this.setState((state) => ({
          ...state,
          countryList: response.data,
        }));
      }
    });
  };

  handleGetSitesList = async () => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    countrySiteService
      .get_sites_list({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
      })
      .then((response) => {
        if (response.data) {
          this.setState((state) => ({
            ...state,
            sitesCount: response.data.length,
            sitesList: groupBy(response.data, 'countryName'),
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handleAddNewSite = async (params) => {
    countrySiteService
      .add_site({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        countryId: params.country,
        siteName: params.siteName,
        details: {
          address: params.siteAddress,
        },
      })
      .then((response) => {
        if (response.status) {
          this.handleGetSitesList();
          this.handleAddSiteModalDisplay(false);
        }
      });
  };

  handleEditSite = async (params) => {
    countrySiteService
      .edit_site({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        siteId: params.siteId,
        siteName: params.siteName,
        details: {
          address: params.siteAddress,
        },
      })
      .then((response) => {
        if (response.status) {
          toast.success('Site updated successfully');
          this.handleGetSitesList();
          this.handleEditSiteModalDisplay(false);
        }
      });
  };

  handleSiteDeletion = async (siteId) => {
    countrySiteService
      .delete_site({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        siteId,
      })
      .then((response) => {
        if (response.status) {
          this.handleGetSitesList();
        }
      });
  };

  // Add New Team Modal Display
  handleAddSiteModalDisplay = (dState) => {
    this.setState((state) => ({
      ...state,
      showAddSiteModal: dState,
    }));
  };

  // Add New Team Modal Display
  handleEditSiteModalDisplay = (dState) => {
    this.setState((state) => ({
      ...state,
      showEditSiteModal: dState,
    }));
  };

  handleSelectedSite = (site) => {
    this.setState((state) => ({
      ...state,
      selectedSite: site,
    }));
  };

  render() {
    const {
      isLoading,
      showAddSiteModal,
      showEditSiteModal,
      selectedSite,
      countryList,
      sitesCount,
      sitesList,
    } = this.state;
    const { permissions } = this.props;
    return (
      <Layout pageHeading={this.pageHeading}>
        <Row className="justify-content-center">
          <Col className="col-12">
            <Card className="mb-5">
              <Card.Header>
                <h4 className="m-0">Country & Sites</h4>
                {permissions &&
                  permissions.includes('country_sites_manage') && (
                    <AddNewSite
                      showAddSiteModal={showAddSiteModal}
                      handleAddSiteModalDisplay={this.handleAddSiteModalDisplay}
                      countryList={countryList}
                      handleAddNewSite={this.handleAddNewSite}
                    />
                  )}
              </Card.Header>
              <Card.Body>
                <ListGroup>
                  <Accordion>
                    {Object.entries(sitesList).map(
                      ([country, sites], index) => (
                        <ListGroup.Item key={`${index}-${country}`}>
                          <Row className="align-items-center">
                            <Col>
                              <AccordionToggle
                                eventKey={`team${index}`}
                                className="text-start"
                              >
                                <div className="ps-3">
                                  <span>{country}</span>{' '}
                                  <span className="text-muted">
                                    ({sites.length}{' '}
                                    {sites.length > 1 ? 'Sites' : 'Site'})
                                  </span>
                                </div>
                              </AccordionToggle>
                            </Col>
                          </Row>
                          <Accordion.Collapse eventKey={`team${index}`}>
                            <ul className="list-group list-group-flush list">
                              {sites.map((site, sIndex) => (
                                <li
                                  className="list-group-item ps-5"
                                  key={`${sIndex}-${site._id}`}
                                >
                                  <Row className="justify-content-center">
                                    <Col className="ps-0">{site.siteName}</Col>
                                    <Col className="col-auto">
                                      <Dropdown
                                        className="card-dropdown"
                                        style={{
                                          position: 'relative',
                                          top: '0',
                                          right: '0',
                                        }}
                                        id={`${site._id}`}
                                      >
                                        <Dropdown.Toggle
                                          as={Link}
                                          to={{ hash: '#' }}
                                          className="dropdown-ellipses dropdown-toggle"
                                        >
                                          <i className="mdi mdi-dots-vertical" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu align="left">
                                          <Dropdown.Item
                                            onClick={() => {
                                              this.handleEditSiteModalDisplay(
                                                true
                                              );
                                              this.handleSelectedSite({
                                                ...site,
                                              });
                                            }}
                                          >
                                            Edit Site
                                          </Dropdown.Item>
                                          <DeleteTeam
                                            deleteProp={() =>
                                              this.handleSiteDeletion(site._id)
                                            }
                                          />
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </Col>
                                  </Row>
                                </li>
                              ))}
                            </ul>
                          </Accordion.Collapse>
                        </ListGroup.Item>
                      )
                    )}
                  </Accordion>
                </ListGroup>

                {showEditSiteModal && selectedSite && (
                  <EditSite
                    selectedSite={selectedSite}
                    showEditSiteModal={showEditSiteModal}
                    handleEditSiteModalDisplay={this.handleEditSiteModalDisplay}
                    handleEditSite={this.handleEditSite}
                  />
                )}
                {!isLoading && sitesCount < 1 && (
                  <NoDataAlert content="No sites are created yet." />
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* Loader */}
        {isLoading && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.permissionsReducer,
});

CountryAndSites.propTypes = {
  permissions: PropTypes.array,
};

export default connect(mapStateToProps)(CountryAndSites);
